import regExp from "@/common/regExp"

    function ceilFromUnitString(el){
        return parseInt(Math.round(el.replace('px','')))

    }
export default ceilFromUnitString
